var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',{staticClass:"row"},[_c('div',{staticClass:"col-sm-7"},[_c('h2',[_vm._v(_vm._s(this.title))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_vm._t("default")],2)]),_vm._v(" "),_c('hr')])
}
var staticRenderFns = []

export { render, staticRenderFns }